module.exports = __webpack_public_path__ + "img/header.2d641155.jpg";